module.exports = __webpack_public_path__ + "static/media/investpic1@3x.0a24ef83.png";